import Cookies from 'js-cookie';
import parser from 'ua-parser-js';
import axios from 'axios';
const _props = require('../../../props')

let _domain = (/(dev.|test.)?yitong.com(:\d+)?/.exec(location.host) || [])[0];
let _YitongToken = {
  domain: _domain,
  tokenKey: 'YitongToken@' + (_domain || ''),
  get: function () {
    return Cookies.get(_YitongToken.tokenKey) || '';
  },
  set: function (token) {
    return Cookies.set(_YitongToken.tokenKey, token || '', {
      expires: 30,
      domain: _YitongToken.domain,
      path: '/'
    });
  }
}

let ytLoading = str => {
  console.log(str)
}

let ytToast = () => {
  return new Promise((resolve) => {
    return resolve()
  })
}

let inWhiteList = /\/login|\/login.html$/.test(location.pathname)

let _requestingCount = 0;

const _handleRequestLoading = () => {
    !_requestingCount && ytLoading("show")
    _requestingCount++;
}

const _handleResponseLoading = () => {
    _requestingCount--;
    !_requestingCount && ytLoading("hide")
}

const _handleLoading = (isUse, isShow) => {
    if(isUse == false) { return }
    isShow ? _handleRequestLoading() : _handleResponseLoading()
}

let _axios = axios.create({
  baseURL: _props.apiBase || ('//api.' + (_domain || 'dev.yitong.com') ),
  params: {
      token: _YitongToken.get() || null
  },
  timeout: 60000,
  headers: {
      'Content-Type': 'application/json;charset=utf-8',
      'Authorization': 'Bearer ' + _YitongToken.get(),
      'X-YT-AppKey': (_props.appKey ? _props.appKey : "")
  },
  responseType: 'json'
});

// request拦截
_axios.interceptors.request.use((config) => {
  _handleLoading(config._useLoading, true)
  return config
},(error) => {
  return Promise.reject(error)
})

// response拦截
_axios.interceptors.response.use(function(response) {
  _handleLoading(response.config._useLoading)
  if (response.data.code === 1) {
      return response.data;
  }else{
      if(response.data.code === 100 && !inWhiteList){
          location.href = '/login?back=' + window.location.href
      }
      return ytToast(response.data.message).then(function() {
          return Promise.reject(response.data);
      });
  }
}, function(error) {
  _handleLoading(error.config._useLoading)
  return Promise.reject(error);
});

export const $http = _axios
export const YitongToken = _YitongToken
export const props = _props
export const domain = _domain || ''
export function toLogin() {
  location.href = '/login?back=' + location.href
}
export const ua = parser(navigator.userAgent);
export const kernel = (function() {
  var agent = navigator.userAgent.toLowerCase();
  var regStr_ie = /msie [\d.]+;/gi;
  var regStr_ff = /firefox\/[\d.]+/gi;
  var regStr_chrome = /chrome\/[\d.]+/gi;
  var regStr_saf = /safari\/[\d.]+/gi;
  var result = null;
  //IE
  if (agent.indexOf('msie') > 0) {
    result = agent.match(regStr_ie);
  }
  //firefox
  if (agent.indexOf('firefox') > 0) {
    result = agent.match(regStr_ff);
  }
  //Chrome
  if (agent.indexOf('chrome') > 0) {
    result = agent.match(regStr_chrome);
  }
  //Safari
  if (agent.indexOf('safari') > 0 && agent.indexOf('chrome') < 0) {
    result = agent.match(regStr_saf);
  }
  return result[0].replace(' ', '/');
})();